/**
 * ChatMessage Component
 *
 * Displays a single message in the chat conversation.
 */

import React from 'react';

export interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ role, content }) => {
  const isUser = role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div
        className={`max-w-[80%] rounded-lg px-4 py-2.5 ${
          isUser
            ? 'bg-primary text-white'
            : 'bg-surface border border-border text-text'
        }`}
      >
        <div className="text-sm whitespace-pre-wrap break-words">{content}</div>
      </div>
    </div>
  );
};
